import { QNImageUtil } from '@/utils'

export function resolveUnionMatchIcon(parentGame) {
  if (!parentGame || !parentGame.unionMatchIcon) {
    return ''
  }
  return String(parentGame.unionMatchIcon)
}

export function resolveTeamBadge(team) {
  if (!team) {
    return ''
  }
  return team.badge || team.logo || ''
}

export function resolveTeamLogoSource(team, matchLogo) {
  return resolveTeamBadge(team) || matchLogo || ''
}

export function resolveTeamLogoUrl(team, matchLogo, width, height) {
  var source = resolveTeamLogoSource(team, matchLogo)
  if (!source) {
    return ''
  }
  return QNImageUtil.imageView(source, width, height)
}
